import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { Network } from "@ionic-native/network/ngx";
import { Network } from '@capacitor/network';
import { BehaviorSubject, Observable } from 'rxjs';
import { ModalController, Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { OfflineModalComponent } from 'src/app/components/offline-modal/offline-modal.component';
import { AppPlatformService } from '../platform/app-platform.service';

/*
  Generated class for the ConexionServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
export enum ConnectionStatus {
  Online,
  Offline,
}
@Injectable({ providedIn: 'root' })
export class ConexionServiceProvider {
  private offlineModal: HTMLIonModalElement;

  //   private hasConnection = new BehaviorSubject(false);
  private status: BehaviorSubject<ConnectionStatus> = new BehaviorSubject(
    ConnectionStatus.Offline
  );

  constructor(
    // private network: Network,
    private platform: Platform,
    public http: HttpClient,
    public router: Router,
    public modalCtrl: ModalController,
    private appPlatformService:AppPlatformService,

  ) {
    console.log('network');
  }

  public async initializeNetworkEvents() {
     if(this.appPlatformService.isAppPlatform()) {
       Network.addListener('networkStatusChange', (status) => {
         console.log('1*+*+* addListener Network status changed', status);

         if (status.connected) {
           //solo si habrá una transición de offline a online
           if (this.status.getValue() === ConnectionStatus.Offline) {
             console.log('WE ARE ONLINE initializeNetworkEvents');
             const forceOffline = localStorage.getItem('chooseOffline');
             if ( forceOffline && forceOffline === 'true' && status.connectionType !== 'none') {
               console.log('offline switch is active');
             } else {
               this.updateNetworkStatus(ConnectionStatus.Online);
             }
           }
         } else {
            //solo si habrá una transición de online a offline
           if (this.status.getValue() === ConnectionStatus.Online) {
             console.log('WE ARE OFFLINE initializeNetworkEvents');
             this.updateNetworkStatus(ConnectionStatus.Offline);
           }
         }
       });

       const statusObj = await Network.getStatus();
       console.log('1*+*+* Network getStatus statusObj:', statusObj);

       let status = statusObj.connectionType !== 'none'
           ? ConnectionStatus.Online
           : ConnectionStatus.Offline;
       this.status.next(status);
       console.log('1*+*+* initialize network service22: ', this.status.getValue());
       if (status == ConnectionStatus.Offline) {
         console.log('1*+*+*offline - redirect from service!! connectionType:**', statusObj.connectionType);
         //si tiene coneción
         if (statusObj.connectionType !== 'none') {
           this.router.navigate(['cursos']);
         } else {
           // this.router.navigate(['offline-message']);
           this.router.navigate(['offline-message']);
         }
       };
     };

  }

  public async updateNetworkStatus(
    status: ConnectionStatus,
    fromTopic = false
  ) {
    if(this.appPlatformService.isAppPlatform()){
      this.status.next(status);

      if (status == ConnectionStatus.Offline && !fromTopic) {
        console.log('offline - redirect from service!!');
        //si tiene coneción
        const statusObj = await Network.getStatus();
        if (statusObj.connectionType !== 'none') {
          this.router.navigate(['cursos']);
        } else {
          // this.router.navigate(['offline-message']);
          this.showOfflineMsgModal()
        }
      }

      if (status == ConnectionStatus.Online) {
        if (!fromTopic) {
          console.log('online - redirect from service!!');
          this.router.navigate(['anuncios']);
        };
        if (this.offlineModal) {
          this.offlineModal.dismiss();
          this.offlineModal = null;
        };
      }
    };
  }

  public onNetworkChange(): Observable<ConnectionStatus> {
    return this.status.asObservable();
  }

  public getCurrentNetworkStatus(): ConnectionStatus {
    return this.status.getValue();
  }
  public async getDeviceNetworkType(): Promise<any> {
    //	return this.network.type;
    const statusObj = await Network.getStatus();
    return statusObj.connectionType;
  }

  async showOfflineMsgModal() {
    this.offlineModal = await this.modalCtrl.create({
      component: OfflineModalComponent,
      backdropDismiss: true,
      cssClass: "basic-modal",
      componentProps: {
        // title: "Estás por descargar un checklist",
        // buttonText: "Iniciar",
        customStyle: "w-11/12 md:w-108",
        // projectedContent: this.confirmChecklistDownloadModalContent,
      },
    });
    await this.offlineModal.present();
    this.offlineModal.onDidDismiss()
    .then(() => this.offlineModal = null)
    .catch((error) => console.log(error));

  }


}
